
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M211.421 155.079C221.892 139.273 228 120.338 228 100 228 44.86 183.14 0 128 0S28 44.86 28 100c0 20.338 6.108 39.273 16.579 55.079C18.005 169.985 0 198.424 0 231v89c0 26.039 15.629 48.494 38 58.479V448c0 35.29 28.71 64 64 64h52c35.29 0 64-28.71 64-64v-69.521c22.371-9.984 38-32.44 38-58.479v-89c0-32.576-18.005-61.015-44.579-75.921zM128 48c28.719 0 52 23.281 52 52s-23.281 52-52 52-52-23.281-52-52 23.281-52 52-52zm80 272c0 8.8-7.2 16-16 16h-22v112c0 8.837-7.163 16-16 16h-52c-8.837 0-16-7.163-16-16V336H64c-8.837 0-16-7.163-16-16v-89c0-19.793 15.074-39 40.818-39 24.961 10.671 53.4 10.672 78.364 0 25.37 0 40.818 18.885 40.818 39v89z","fill":"currentColor"}})])
          )
        }
      }
    